import { render, staticRenderFns } from "./PaymentCategoryTypes.vue?vue&type=template&id=46d70b93&"
import script from "./PaymentCategoryTypes.vue?vue&type=script&lang=js&"
export * from "./PaymentCategoryTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports